import { useCallback } from 'react';
import { useSearchParams } from 'react-router';
import { atom, useRecoilValue, useSetRecoilState } from 'recoil';
import { useScheduledBroadcast } from './scheduleState';
export const streamState = atom({
    key: 'streamState',
    default: {},
});
export function useStreamDirection(streamPartId) {
    const directions = useRecoilValue(streamState) || {};
    const mode = useSearchParams()[0].get('mode');
    const broadcast = useScheduledBroadcast(streamPartId);
    if (!streamPartId) {
        return undefined;
    }
    if (mode === 'viewer') {
        return 'incoming';
    }
    if (mode === 'broadcaster' || broadcast) {
        return 'outgoing';
    }
    return directions[streamPartId];
}
export function useSetStreamDirectionCallback() {
    const setStreamDirection = useSetRecoilState(streamState);
    return useCallback((streamPartId, value) => {
        if (value) {
            setStreamDirection((directions) => ({
                ...directions,
                [streamPartId]: value,
            }));
            return;
        }
        setStreamDirection(({ [streamPartId]: _, ...directions }) => directions);
    }, [setStreamDirection]);
}
